import { NgModule } from "@angular/core";
import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { ConfigComponent } from "./config/config.component";
import { EntregasComponent } from "./entregas/entregas.component";
import { HomeComponent } from "./home/home.component";
import { KanbanViewComponent } from "./kanban-view/kanban-view.component";
import { ListViewComponent } from "./list-view/list-view.component";
import { PerfilComponent } from "./perfil/perfil.component";
import { PedidoService } from "./services/pedido.service";
import { ImpressaoComponent } from "./impressao/impressao.component";

const routes: Routes = [
  { path: "", component: HomeComponent },
  { path: "codigo/:codigo", component: HomeComponent },
  { path: "pedidos", component: KanbanViewComponent, pathMatch: "full" },
  { path: "impressao", component: ImpressaoComponent, pathMatch: "full" },
  { path: "list", component: ListViewComponent, pathMatch: "full" },
  { path: "profile", component: PerfilComponent, pathMatch: "full" },
  { path: "config", component: ConfigComponent, pathMatch: "full" },
  { path: "entregas", component: EntregasComponent, pathMatch: "full" },
  { path: "pedidos", component: PedidoService, pathMatch: "full" },
];

const routerOptions: ExtraOptions = {
  useHash: false,
  anchorScrolling: "enabled",
  scrollPositionRestoration: "enabled",
  scrollOffset: [0, 0],
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
